import React, { FC, useContext, useEffect } from "react";
import imagePng from "images/our-features.webp";
import HeroSearchForm from "components/HeroSearchForm/HeroSearchForm";
import AppContext from 'AppContext';
import { useTranslation } from 'react-i18next';

export interface SectionHeroProps {
  className?: string;
}

const SectionHero: FC<SectionHeroProps> = ({ className = "" }) => {
  const { setVoyageInfo, setAfficheMenuMobile } = useContext(AppContext);
  const { t } = useTranslation();

  useEffect( () => {
    setVoyageInfo(null);
    setAfficheMenuMobile(true);
  }, []);

  return (
    <div
      className={`nc-SectionHero flex flex-col-reverse lg:flex-col relative ${className}`}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="flex-shrink-0 lg:w-1/2 flex flex-col items-start space-y-8 sm:space-y-10 pb-6 lg:pb-48 xl:pr-14 lg:mr-10 xl:mr-0">
          <h1 className="max-w-3xl

              text-2xl
              font-black
              tracking-tight
              text-neutral-950
              dark:text-white

              sm:text-3xl
              lg:text-5xl
              xl:text-7xl

              leading-[1.03]">
            {t('planificateur3')}&nbsp;
          
         <span
    className="
      bg-gradient-to-r
      from-rose-500
      via-purple-500
      to-indigo-500
      bg-clip-text
      text-transparent
    "
  >
    {t('planificateur4')}
  </span>
          </h1>
          <span className="  mt-6
              max-w-2xl

              text-base
              leading-relaxed
              text-neutral-600
              dark:text-neutral-300

              sm:text-md
              lg:text-lg">
            {t('description')}
          </span>
        </div>
        <div className="flex-grow flex justify-center sm:items-center">
          <img className="w-[50%] sm:w-[50%] md:w-[50%] lg:w-full xl:w-full imageAccueil" src={imagePng} alt="hero" />
        </div>
      </div>

      <div className="hidden lg:block z-10 mb-12 lg:mb-0 lg:-mt-40 w-full">
        <HeroSearchForm />
      </div>
    </div>
  );
};

export default SectionHero;
